export default "__VITE_ASSET__BXdfwS5a__"